export const windows = {
    johnDeereApiAuth: "johnDeereApiAuth",
};
